var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._l(_vm.language, function (item, index) {
            return [
              _c("div", { key: "Language" + index, staticClass: "col-md-6" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-title" }, [
                    _c("span", { style: { color: _vm.fontColor } }, [
                      _vm._v(" 語言種類 "),
                      _c("span", { staticClass: "en-text" }, [
                        _vm._v("Language"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-value" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { filterable: "", placeholder: "請選擇" },
                          model: {
                            value: item.LanguageGuid,
                            callback: function ($$v) {
                              _vm.$set(item, "LanguageGuid", $$v)
                            },
                            expression: "item.LanguageGuid",
                          },
                        },
                        _vm._l(_vm.languageOptions, function (language) {
                          return _c("el-option", {
                            key: language.Guid,
                            attrs: {
                              label: language.Name,
                              value: language.Guid,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { key: "LanguageDescription" + index, staticClass: "col-md-6" },
                [
                  item.LanguageGuid === "11111111-1111-1111-1111-111111111111"
                    ? [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-title" }, [
                            _c("span", { style: { color: _vm.fontColor } }, [
                              _vm._v(" 語言描述 "),
                              _c("span", { staticClass: "en-text" }, [
                                _vm._v("Language"),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "field-value" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.LanguageDescription,
                                  expression: "item.LanguageDescription",
                                },
                              ],
                              attrs: {
                                type: "text",
                                maxlength: "200",
                                autocomplete: "off",
                                readonly: "",
                              },
                              domProps: { value: item.LanguageDescription },
                              on: {
                                focus: function ($event) {
                                  return _vm.$common.removeReadonly($event)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    item,
                                    "LanguageDescription",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("div", { key: "Listen" + index, staticClass: "col-md-6" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-title" }, [
                    _c("span", { style: { color: _vm.fontColor } }, [
                      _vm._v(" Listening Skill "),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-value" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { placeholder: "請選擇" },
                          model: {
                            value: item.ListenGuid,
                            callback: function ($$v) {
                              _vm.$set(item, "ListenGuid", $$v)
                            },
                            expression: "item.ListenGuid",
                          },
                        },
                        _vm._l(_vm.degreeOptions, function (degree) {
                          return _c("el-option", {
                            key: degree.Guid,
                            attrs: { label: degree.Name, value: degree.Guid },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { key: "Speak" + index, staticClass: "col-md-6" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-title" }, [
                    _c("span", { style: { color: _vm.fontColor } }, [
                      _vm._v(" Speaking Skill "),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-value" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { placeholder: "請選擇" },
                          model: {
                            value: item.SpeakGuid,
                            callback: function ($$v) {
                              _vm.$set(item, "SpeakGuid", $$v)
                            },
                            expression: "item.SpeakGuid",
                          },
                        },
                        _vm._l(_vm.degreeOptions, function (degree) {
                          return _c("el-option", {
                            key: degree.Guid,
                            attrs: { label: degree.Name, value: degree.Guid },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { key: "Read" + index, staticClass: "col-md-6" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-title" }, [
                    _c("span", { style: { color: _vm.fontColor } }, [
                      _vm._v(" Reading Skill "),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-value" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { placeholder: "請選擇" },
                          model: {
                            value: item.ReadGuid,
                            callback: function ($$v) {
                              _vm.$set(item, "ReadGuid", $$v)
                            },
                            expression: "item.ReadGuid",
                          },
                        },
                        _vm._l(_vm.degreeOptions, function (degree) {
                          return _c("el-option", {
                            key: degree.Guid,
                            attrs: { label: degree.Name, value: degree.Guid },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { key: "Write" + index, staticClass: "col-md-6" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-title" }, [
                    _c("span", { style: { color: _vm.fontColor } }, [
                      _vm._v(" Writing Skill "),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-value" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { placeholder: "請選擇" },
                          model: {
                            value: item.WriteGuid,
                            callback: function ($$v) {
                              _vm.$set(item, "WriteGuid", $$v)
                            },
                            expression: "item.WriteGuid",
                          },
                        },
                        _vm._l(_vm.degreeOptions, function (degree) {
                          return _c("el-option", {
                            key: degree.Guid,
                            attrs: { label: degree.Name, value: degree.Guid },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { key: "LanguageTest" + index, staticClass: "col-md-6" },
                [
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "field-title" }, [
                      _c("span", { style: { color: _vm.fontColor } }, [
                        _vm._v(" 語言檢定 "),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v("Language Verification"),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "field-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.LanguageTest,
                            expression: "item.LanguageTest",
                          },
                        ],
                        attrs: {
                          type: "text",
                          maxlength: "200",
                          autocomplete: "off",
                          readonly: "",
                        },
                        domProps: { value: item.LanguageTest },
                        on: {
                          focus: function ($event) {
                            return _vm.$common.removeReadonly($event)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(item, "LanguageTest", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
              _c("div", { key: "button" + index, staticClass: "col-md-6" }, [
                _vm.language.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "del-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.del(index)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          }),
        ],
        2
      ),
      _c("div", { staticClass: "edit-btn-wrap" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm add-btn",
            attrs: { type: "button" },
            on: { click: _vm.add },
          },
          [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "put-btn",
            attrs: { type: "button" },
            on: { click: _vm.saveLanguage },
          },
          [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }